import { FormResult, IFormField, IImage, IMdBody } from '../../../types/shared';

export interface CalculatorData {
  __typename: string;
  id: string;
  title: string;
  inputs: (IFormField | FormResult)[];
  results: FormResult[];
  resultsImage?: IImage;
  disclaimer?: IMdBody;
}

export interface CalculatorProps {
  id: string;
  title: string;
  inputs: (IFormField | FormResult)[];
  results: FormResult[];
  resultsImage?: IImage;
  disclaimer?: IMdBody;
  trackingName: string;
  anchorName?: string;
  __typename?: string;
}

export interface MainResultProps {
  image?: IImage;
  result: FormResult;
  inputValues: InputValue[];
  onCalculate?: (name: string, value: string) => void;
  trackingData?: {
    id: string;
    trackingName: string;
  };
}

export interface ResultListProps {
  results: FormResult[];
  inputValues: InputValue[];
  onCalculate?: (name: string, value: string) => void;
}

export interface DisclaimerProps {
  body: IMdBody;
}

export interface InputValue {
  id: string;
  value: string;
}

export interface InputValueAction {
  type: 'set' | 'initialize';
  name: string;
  value: string;
  initialValues?: InputValue[];
}

export enum InputActions {
  SET = 'set',
  INITIALIZE = 'initialize',
}
